var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.667 19H3.66695C2.98414 19 2.32733 18.7382 1.83183 18.2684C1.33941 17.8015 1.04358 17.1646 1.00429 16.4875L1 16.3202V3.667C1 2.24616 2.11102 1.08465 3.51221 1.0043L3.67982 1H16.333C17.7538 1 18.9153 2.11101 18.9957 3.51219L19 3.67983V16.333C19 17.7538 17.889 18.9153 16.4878 18.9957L16.3202 19H3.667Z",
    stroke: "#828282",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector3);
export default __webpack_public_path__ + "static/media/Vector-3.56ef0bda700a0b50095d76edec62af80.svg";
export { ForwardRef as ReactComponent };